
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  imports: [],
  standalone: true,
  selector: 'register-success',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './register-success.component.html',
})
export class RegisterSuccessComponent implements OnInit {
  domain: string = '';
  constructor() {
    this.domain = window.location.hostname.toUpperCase();
  }

  ngOnInit(): void {}
}
